import { IHDYHAU, IUsePage, useHDYHAU, usePage } from '@omaze/cms';
import { ISelectOption, OzSelectInput } from '@omaze/omaze-ui';
import React, { Dispatch, Fragment, ReactElement, SetStateAction, useMemo, useState } from 'react';

import { SkeletonLoading } from './SkeletonLoading/SkeletonLoading';

type IOption = {
    name: string;
    value: string;
};

export function HDYHAU (): ReactElement | null {
    const { loading, page }: IUsePage = usePage(window.ozShopifyApp.dataSources.cosmic.pages.cart);
    const [selectedHDYHAU, setSelectedHDYHAU]: [string, Dispatch<SetStateAction<string>>] = useState('');
    const hdyhau: IHDYHAU | null = useHDYHAU(page);

    const options: IOption[] = useMemo((): IOption[] => {
        if (!hdyhau) {
            return [];
        }

        return hdyhau.answers.map((answer: string): IOption => {
            return {
                name: answer,
                value: answer,
            };
        });
    }, [hdyhau?.answers]);

    if (loading) {
        return (
            <div data-testid='hdyhauLoadingTest'>
                <SkeletonLoading />
            </div>
        );
    }

    if (!hdyhau) {
        return null;
    }

    return (
        <Fragment>
            <div className='font-bold font-gellix'>
                {hdyhau.question}
            </div>
            <OzSelectInput
                onChange={(option: ISelectOption): void => {
                    setSelectedHDYHAU(option.value);
                }}
                label=''
                options={options}
                placeholder='Select'
                data-testid='hdyhau'
                className='mt-2 mb-1'
            />
            <input
                type='hidden'
                name={`attributes[${hdyhau.question}]`}
                value={selectedHDYHAU}
            />
        </Fragment>
    );
}
